export default class Polyfill {
    static removeHtmlElementNode(element) {
            if (element.parentNode !== null)
                element.parentNode.removeChild(element);
    }

    static createNewEvent(eventName) {
        let event = null;

        if(typeof(Event) === 'function') {
            event = new Event(eventName);
        }else{
            event = document.createEvent('Event');
            event.initEvent(eventName, true, true);
        }
        return event;
    }
}
